import React from 'react'

import{
    InboxIcon,
  CurrencyDollarIcon
}from "@heroicons/react/24/outline"

import { faFile, faStopCircle } from '@fortawesome/free-solid-svg-icons'

import useUser from '../../hooks/useUser';
import SideBarItem from '../SideBarItem';

function SideBar() {

  const { user } = useUser() 
    
  return (    
        <div className="w-[360px] bg-gray-100 h-screen shadow-lg rounded">
            <div className="p-5 text-2xl font-semibold bg-gray-100 rounded-lg shadow-md" >
                {user?.customer_name}       
            </div>        
            <div className="ml-1 mr-1 mt-2 overflow-y-auto h-4/6">            
                <SideBarItem key="doc" routing={"/misc/doc"} addrSeq="0" name="Documents" description="" Icon={faFile} hero={false} />        
            </div>
        </div>
  )
}
export default SideBar